import React, {useState} from 'react';
//import ReactDOM from 'react-dom';
import {postApi} from '../../utils/functions';

import {
  PaymentElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js';

import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

export default function StripePayment(props) {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);

  const handleError = (error) => {
    setLoading(false);
    setErrorMessage(error.message);
  }

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setLoading(true);

    // Trigger form validation and wallet collection
    const {error: submitError} = await elements.submit();
    if (submitError) {
      handleError(submitError);
      return;
    }

    // Create the SetupIntent and obtain clientSecret
    /*const res = await putApi("/create-intent", {
      method: "POST",
    });*/
    let params = new URLSearchParams();
    params.append('order', Intl.DateTimeFormat().resolvedOptions().timeZone);
    let client_secret = await postApi(`/v3/account/stripeintent`, params);

    //const {client_secret: clientSecret} = await res.json();

    // Confirm the SetupIntent using the details collected by the Payment Element
    const {error} = await stripe.confirmSetup({
      elements,
      clientSecret: client_secret.data.client_secret,
      confirmParams: {
        return_url: process.env.NODE_ENV==="production"?`https://portal.ultrastream.io${window.location.pathname}`:`https://cloud1.ultrastream.io:3000${window.location.pathname}`,
      },
    });

    if (error) {
      // This point is only reached if there's an immediate error when
      // confirming the setup. Show the error to your customer (for example, payment details incomplete)
      handleError(error);
    } else {
      // Your customer is redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer is redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }



  };

  return (
    
      <form onSubmit={handleSubmit}>
        <PaymentElement options={{
          layout: 'tabs',
        }}/>
        <ButtonGroup className="mt-3">
          <Button size="sm" type="submit" disabled={!stripe || loading}>
            Continue
          </Button>
          <Button size="sm" onClick={props.cancel}>
            Cancel
          </Button>
        </ButtonGroup>
        {errorMessage && <div>{errorMessage}</div>}
      </form>
    
  );
}
